module.exports = __webpack_public_path__ + "img/ms-add-account2.acd87987.png";